<div class="fixed bottom-5 left-1/2 z-[1000] flex flex-col gap-2 max-w-[370px] -translate-x-1/2">
	<app-toast *ngFor="let toast of toasts$ | async; trackBy: trackByFn" [toast]="toast" (close)="removeToast(toast.id)"></app-toast>
</div>
